/**
 * Production console override
 * Automatically removes console logs in production builds
 */

// Only apply console overrides in true production
const isProduction = import.meta.env.PROD && import.meta.env.MODE === 'production';

if (isProduction) {
  // Preserve only error logs in production for debugging critical issues
  const originalError = console.error;
  const originalWarn = console.warn;
  
  // Override all console methods
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.trace = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
  console.time = () => {};
  console.timeEnd = () => {};
  
  // Keep errors and warnings for critical issues (but clean them up)
  console.error = (...args: any[]) => {
    // Only show errors in production if they're critical
    if (args.some(arg => 
      typeof arg === 'string' && (
        arg.includes('[ERROR]') || 
        arg.includes('Authentication') ||
        arg.includes('Payment') ||
        arg.includes('Database')
      )
    )) {
      originalError(...args);
    }
  };
  
  console.warn = (...args: any[]) => {
    // Only show warnings for critical system issues
    if (args.some(arg => 
      typeof arg === 'string' && (
        arg.includes('[WARN]') || 
        arg.includes('Authentication') ||
        arg.includes('Payment') ||
        arg.includes('Network')
      )
    )) {
      originalWarn(...args);
    }
  };
}

export {};